import { render, staticRenderFns } from "./ExcursionButtons.vue?vue&type=template&id=2fabda42&scoped=true"
import script from "./ExcursionButtons.vue?vue&type=script&lang=ts"
export * from "./ExcursionButtons.vue?vue&type=script&lang=ts"
import style0 from "./ExcursionButtons.vue?vue&type=style&index=0&id=2fabda42&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fabda42",
  null
  
)

export default component.exports